import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Scanner from "../../components/barcode/scanner";
import MetaData, {Type} from "../../components/metadata";
import Header from "../../components/header";
import React from "react";
import Footer from "../../components/footer";
import {useTranslation} from "next-i18next";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Scan()
{
    const { t } = useTranslation();

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={Type.Website}
                title={t('scan.barcode')}
                description={t('scan.lead', { ns: 'glossary' })}
                keywords={[t('scan.barcode')]}
                imageURL={process.env.logoURL}
                canonical={false}
                urlOnlyForThisCountry={false}
            />

            {/* Header */}
            <Header />

            {/* Scanner */}
            <Scanner modal={false} />

            {/* Footer */}
            <Footer />
        </>
    );
}

/**
 *
 * @param context
 * @returns {Promise<{props: {}}>}
 */
export async function getStaticProps(context) {
    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'ingredient-types'])),
        }
    };
}